import React, { useState } from 'react';
import styles from './LearningPaths.module.scss';
import { CustomButton } from 'shared_ui_components';
import CreateLearningPath from '../Components/CreateLearningPath/CreateLearningPath';
import { useLearningPathsStore } from '../LearningPaths.store';
import SeeLearningPaths from '../Components/SeeLearningPaths/SeeLearningPaths';
import { useGetFF } from '@fstack-tech/ff_react_module';
import LearningPathFilterSelector from '../../LearningPathFilterSelector';

const LearningPathsView = () => {
  const openModal = useLearningPathsStore((state) => state?.openCreateModal);
  const { isEnabled: ff_learningPaths } = useGetFF({ flag_id: 'learning_paths' });
  const [filter, setFilter] = useState('published');
  const handleFilterChange = (e) => setFilter(e.value);
  return (
    <>
      <CreateLearningPath />
      <div className={styles.container}>
        <div className={styles.header}>
          {!ff_learningPaths ? (
            <div className={styles.headerText}>
              <div className={styles.headerTitle}>Learning paths</div>
              <div className={styles.headerDescription}>
                Enhance the sales training experience by providing personalized learning paths
                tailored to each sales rep needs.
              </div>
            </div>
          ) : (
            <div></div>
          )}

          <div className={styles.actionButtons}>
            {ff_learningPaths && (
              <LearningPathFilterSelector handleFilterChange={handleFilterChange} filter={filter} />
            )}
            <CustomButton onClick={openModal}>
              {ff_learningPaths ? '+ Skill Path' : '+ Add New Learning path'}
            </CustomButton>
          </div>
        </div>
        <SeeLearningPaths filter={filter} />
      </div>
    </>
  );
};

export default LearningPathsView;
